module.exports = __webpack_public_path__ + "static/playstore-939441b3ba497366de897c74998df72e.png";